import Component from './MyDealsForm.container';

export default Component;
